export default __webpack_public_path__ + "c26859fd4c08a46bfc3d84c5680e26ba.svg";